import React, { useEffect } from "react";
import { Navbar, Nav } from "react-bootstrap";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import logo from "../assests/logoc.png";
import De from "../assests/germany.png";
import Fr from "../assests/france.png";
import En from "../assests/uk.png";
import Ar from "../assests/saudi.png";

const StyledHeader = styled(Navbar)`
  background: linear-gradient(to right, white, #0072bb, white);
  padding: 0.8rem 2rem;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;

  &.rtl {
    direction: rtl;
  }

  @media (max-width: 768px) {
    padding: 0.5rem 1rem;
  }
`;

const HeaderContent = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  align-items: center;
  flex-wrap: wrap;

  @media (max-width: 1060px) {
    display: block;

    flex-direction: column;
    align-items: center;
      justify-content: center;

  }
`;

const Logo = styled.img`
  width: 10rem;
  height: auto;

  @media (max-width: 768px) {
    width: 6rem;
  }
`;

const TitleSection = styled.div`
  text-align: center;
  max-width: 100%;

  h1 {
    font-family: 'Black Ops One', sans-serif;
    font-size: 3.5rem;
    font-weight: 900;
    color: #0e0e0e;
    letter-spacing: 0.5rem;
    text-shadow: 2px 2px 5px rgba(0,0,0,0.6);
    text-transform: uppercase;
    margin-bottom: 0.5rem;

    @media (max-width: 768px) {
      font-size: 2rem;
      letter-spacing: 0.2rem;
    }
  }

  h3 {
    font-family: 'Merriweather', serif;
    font-size: 1.2rem;
    font-weight: bold;
    margin-top: 0.4rem;
    padding-top: 0.4rem;
    border-top: 1px solid #ccc;
    text-transform: uppercase;

    @media (max-width: 768px) {
      font-size: 0.9rem;
    }
  }

  .arabic {
    font-family: 'Amiri', serif;
    direction: rtl;
    font-size: 1.6rem;

    @media (max-width: 768px) {
      font-size: 1.1rem;
    }
  }
`;

const NavContainer = styled.div`
  margin-top: 1rem;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

const NavItems = styled(Nav)`
  display: flex;
  gap: 25px;
  font-size: 18px;
  font-weight: bold;
  text-transform: uppercase;

  @media (max-width: 768px) {
    gap: 10px;
    font-size: 14px;
    flex-wrap: wrap;
    justify-content: center;
  }

  .nav-link {
    color: #002147 !important;
    &:hover {
      color: #a3c6e0 !important;
    }
  }
`;

const FlagContainer = styled.div`
  display: flex;
  gap: 10px;
  margin-top: 10px;

  @media (max-width: 768px) {
    gap: 5px;
  }
`;

const Flag = styled.img`
  width: 30px;
  cursor: pointer;

  @media (max-width: 768px) {
    width: 20px;
  }
`;

function Navigation() {
  const { t, i18n } = useTranslation();

  useEffect(() => {
    const savedLanguage = localStorage.getItem("language") || "en";
    i18n.changeLanguage(savedLanguage);

    if (savedLanguage === "ar") {
      document.body.classList.add("rtl");
    } else {
      document.body.classList.remove("rtl");
    }
  }, [i18n]);

  const handleLanguageChange = (lang) => {
    i18n.changeLanguage(lang);
    localStorage.setItem("language", lang);

    if (lang === "ar") {
      document.body.classList.add("rtl");
    } else {
      document.body.classList.remove("rtl");
    }
  };

  return (
    <StyledHeader expand="lg" className={i18n.language === "ar" ? "rtl" : ""}>
      <center>
        <HeaderContent >
        <a href="/">
        <Logo src={logo} alt="Logo Left" />
        </a>
        <TitleSection>
          
          <h1>AIPROPD</h1>
          <h3>Agentur International Professionelle Privat Detektiv</h3>
          <h3>Agency International Professional Private Detective</h3>
          <h3>Agence Professionnelle Internationale D'enquêtes Privées</h3>
          <h3 className="arabic" style={{fontSize: "2rem"}}>الوكالة الدولية المحترفة للتحقيقات الخاصة</h3>
        </TitleSection>
        <a href="/">
        <Logo src={logo} alt="Logo Right" />
        </a>

      </HeaderContent>
      </center>

      <Navbar.Toggle aria-controls="basic-navbar-nav" />
      <Navbar.Collapse id="basic-navbar-nav">
        <NavContainer>
          <NavItems style={{display:"flex", flexDirection:"row"}}>
            <Nav.Link href="#video">{t("HOME")}</Nav.Link>
            <Nav.Link href="#Aboutus">{t("ABOUT US")}</Nav.Link>
            <Nav.Link href="#Services">{t("SERVICES")}</Nav.Link>
            <Nav.Link href="#news">{t("NEWS")}</Nav.Link>
            <Nav.Link href="#Contactus">{t("CONTACT US")}</Nav.Link>
          </NavItems>
          <FlagContainer style={{display:"flex", flexDirection:"row" , gap:"15px"}}>
            <Flag src={De} alt="German" onClick={() => handleLanguageChange("de")} />
            <Flag src={Fr} alt="French" onClick={() => handleLanguageChange("fr")} />
            <Flag src={En} alt="English" onClick={() => handleLanguageChange("en")} />
            <Flag src={Ar} alt="Arabic" onClick={() => handleLanguageChange("ar")} />
          </FlagContainer>
        </NavContainer>
      </Navbar.Collapse>
    </StyledHeader>
  );
}

export default Navigation;
